export default __webpack_public_path__ + "static/media/hero_1.1f0a0af5.jpg";